export const aubreyEvents = (k)=>{
    aubreyHoverEvent(k);
    collision(k);
}

const aubreyHoverEvent = (k)=>{
        k.onHover("aubrey", (omori2) => {
        k.debug.log("Is hovered")
        const select = add([
            rect(120, 122),
            color(217, 217, 217),
            pos(24, 39),
            z(1),
            opacity(0.4),
            "select"
        ])
    })

    k.onHoverEnd("aubrey", (omori)=>{
        k.debug.log("Termino el hover")
        const selectAubrey = k.get("select")[0];
        k.destroy(selectAubrey);
    })
}

const collision = (k) =>{
    const aubrey = k.get("aubrey")[0];
    const omori = k.get("omori")[0];
    aubrey.onUpdate(()=>{
        if (aubrey.isColliding(omori)){
            k.debug.log("collision")
        }
    })
}